export const PDF_DOCUMENT_SECOND_PAGE_NUMBER = 2
export const PAGE_NAME_MAX_LENGTH = 256
